export const COMPANY_ROUTES = {
    LOCATIONS: "/[companyId]/locations",
    USERS: "/[companyId]/users",
    ENERGY: {
        GENERAL: "/[companyId]/energy/general",
        RULESETS: "/[companyId]/energy/rulesets",
        RULESET: "/[companyId]/energy/rulesets/[rulesetId]",
        RULE: "/[companyId]/energy/rulesets/[rulesetId]/rules/[ruleId]",
        NEW_RULE: "/[companyId]/energy/rulesets/[rulesetId]/rules/new",
    },
    INTEGRATION: "/[companyId]/integration",
};

export const LOCATION_ROUTES = {
    DASHBOARD: "/[companyId]/locations/[locationId]/dashboard",
    SPACES: "/[companyId]/locations/[locationId]/spaces",
    DEVICES: "/[companyId]/locations/[locationId]/devices",
    OCCUPANCIES: "/[companyId]/locations/[locationId]/occupancies",
    ENERGY: {
        OVERVIEW: "/[companyId]/locations/[locationId]/energy/overview",
    },
    ANALYZE_TAB: "/[companyId]/locations/[locationId]/analyze/[tabId]",
    MONITOR: "/[companyId]/locations/[locationId]/monitor",
    LOGS: "/[companyId]/locations/[locationId]/logs",
};

const ADMIN_ROUTE_PREFIX = "all";

export const ADMIN_ROUTES = {
    SYSTEMCHECK: `/${ADMIN_ROUTE_PREFIX}/systemcheck`,
    DEVICES: `/${ADMIN_ROUTE_PREFIX}/devices`,
    USERS: `/${ADMIN_ROUTE_PREFIX}/users`,
    MIGRATION: `/${ADMIN_ROUTE_PREFIX}/migration`,
    ANNOUNCEMENTS: `/${ADMIN_ROUTE_PREFIX}/announcements`,
};

export const REDIRECT_ROUTES = {
    REDIRECT: "/redirect",
    INSTALLATION: "/installation",
};
